import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute() {
	const { session, loading } = useAuth();

	if (loading) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-surface">
				<div className="font-label-bold text-on-surface uppercase">
					Loading...
				</div>
			</div>
		);
	}

	if (!session) {
		return <Navigate to="/login" replace />;
	}

	return <Outlet />;
}
